import React from 'react';

import SubsciptionSavingsCalculator from '../../components/SavingsCalculators/SubscriptionSavingsCalculator';
import OnlineOrdersBenefits from '../../components/ForRestaurants/OnlineOrdersBenefits';
import RestaurateurFaq from '../../components/ForRestaurants/RestaurateurFaq';
import { smoothScroll } from '../../app/ui';
import CallMeForm from '../../components/ForRestaurants/CallMeForm';
import PartnerLogos from '../../components/ForRestaurants/PartnerLogos';
import { createDerivedStateFromErrorLogger } from 'Utils/log';
import { OFFER_TYPES, subscriptionPlans } from 'App/config';
import SubscriptionTier from '../../components/ForRestaurants/tiers/SubscriptionTier';
import { getSafeUrlParam } from 'Utils/url-params';

class SubscriptionOffer extends React.Component {
  state = {};

  componentDidMount() {
    document.querySelector('.until-react-spinner').remove();
    smoothScroll();
    const restaurantName = getSafeUrlParam('rn');
    restaurantName && this.setState({ restaurantName: restaurantName.split('-').join(' ') });
  }

  render() {
    return <>
      <section className="for-restaurants-intro">
        <h1 className="fr-title">Sprzedawaj online bez prowizji</h1>
        <h2 className="fr-subtitle">
          {this.state.restaurantName && <div className="mb-3">Oferta OtoStolik dla restauracji <span className="capitalize">{this.state.restaurantName}</span></div>}
          Uruchom <span className="text-primary">zamówienia online</span> na stronie www restaracji <span className="text-primary">z niskim, przewidywalnym kosztem</span>
        </h2>
        <a href="#start-now" className="js-scroll-trigger for-restaurants-cta-btn">Dołącz teraz</a>
      </section>
      <div className="container mb-4">
        <section className="for-restaurants-why pb-3">
          <OnlineOrdersBenefits type={OFFER_TYPES.SELL_WITHOUT_COMMISSION} />
          <SubsciptionSavingsCalculator />
        </section>
      </div>
      <section className="tiers">
        {subscriptionPlans.map(plan => <SubscriptionTier key={plan.label} bestTierLabel={plan.featuredText} plan={plan}>
          <a href="#start-now" className="js-scroll-trigger for-restaurants-cta-btn mt-3">Wybierz</a>
        </SubscriptionTier>)}
      </section>
      <section className="cta-call-me" id="start-now">
        <div className="cta-section__content">
          <h2 className="fr-title">Dołącz do grona naszych partnerów</h2>
          <h5 className="fr-subtitle">Uzupełnij krótki formularz i zacznij sprzedawać online z niskim kosztem</h5>
          <div className="fr-inputs-wrapper">
            <a href="https://admin.otostolik.pl/signup" target="_blank" rel="noopener noreferrer" className="for-restaurants-cta-btn">Dodaj restaurację</a>
          </div>
        </div>
      </section>
      <PartnerLogos />
      <section className="for-restaurants-how text-left">
        <h4 className="home-title home-title--smaller">Wciąż masz pytania?</h4>
        <RestaurateurFaq isSubscription />
      </section>
      <CallMeForm
        id="call-me"
        title="Czy możemy Ci w czymś jeszcze pomóc?"
        text="Podaj numer telefonu - oddzwonimy w ciągu godziny!"
      />
    </>;
  }
}

SubscriptionOffer.getDerivedStateFromError = createDerivedStateFromErrorLogger('SubscriptionOffer');

export default SubscriptionOffer;
